export const messages = {
  en: {
    propertyCommunity: {
      search: {
        title: 'Search Conditions',
        communityId: 'Please enter community ID',
        name: 'Please enter community name'
      },
      list: {
        title: 'Community Information',
        add: 'Join Community',
        quit: 'Delete Community'
      },
      table: {
        communityId: 'Community ID',
        name: 'Community Name',
        nearbyLandmarks: 'Nearby Landmarks',
        cityCode: 'City Code',
        state: 'Status'
      },
      add: {
        title: 'Add Community',
        openCommunity: 'Open Community',
        selectCommunity: 'Optional, please select community',
        functions: 'Functions',
        all: 'All'
      },
      edit: {
        title: 'Edit Community',
        openCommunity: 'Open Community',
        functions: 'Functions',
        all: 'All'
      },
      delete: {
        title: 'Confirm Operation',
        confirm: 'Are you sure to delete this community?',
        cancel: 'Cancel',
        confirmButton: 'Confirm Delete'
      },
      fetchError: 'Failed to fetch community data'
    },

  },
  zh: {
    propertyCommunity: {
      search: {
        title: '查询条件',
        communityId: '请输入项目编号',
        name: '请输入项目名称'
      },
      list: {
        title: '项目信息',
        add: '加入项目',
        quit: '删除项目'
      },
      table: {
        communityId: '项目ID',
        name: '项目名称',
        nearbyLandmarks: '附近地标',
        cityCode: '城市',
        state: '状态'
      },
      add: {
        title: '添加项目',
        openCommunity: '开通项目',
        selectCommunity: '选填，请选择开通项目',
        functions: '功能',
        all: '全部'
      },
      edit: {
        title: '修改项目',
        openCommunity: '开通项目',
        functions: '功能',
        all: '全部'
      },
      delete: {
        title: '请确认您的操作',
        confirm: '确定删除项目吗？',
        cancel: '点错了',
        confirmButton: '确认删除'
      },
      fetchError: '获取项目数据失败'
    },
  }
}